// Какво може да се каже за инвентаризация без да се рендира: анулирана ли е,
// кой текст я представя в колоните (за филтри, търсене, сортиране) и знаковата
// сума. Общо за началния екран, справката и документа.
import type { StocktakeDocument } from "../../../../api/inventoryStocktakes";
import { formatMoney } from "../../components/numbers";

export const isStocktakeAnnulled = (stocktake: StocktakeDocument) =>
  stocktake.status === "annulled" || !!stocktake.deletedAt;

export const stocktakeUserOf = (stocktake: StocktakeDocument) =>
  stocktake.createdByName || "—";
export const stocktakeWarehouseOf = (stocktake: StocktakeDocument) =>
  stocktake.warehouseName || "—";
export const stocktakeReasonOf = (stocktake: StocktakeDocument) =>
  stocktake.reason || "—";

// Знакова стойност на разликите: излишъкът е с „+", липсата носи своя минус
export const formatSignedMoney = (value: number) =>
  `${value > 0 ? "+" : ""}${formatMoney(value)}`;

// Тонът на знакова стойност: зелено излишък, червено липса
export const signedToneClass = (value: number) =>
  value > 0 ? "text-ok-deep" : value < 0 ? "text-danger-ink" : "text-ink";

// Брутото („с ДДС …") се пише само когато се различава от нетото — без ДДС
// (нерегистрирана фирма / 0 %) е същото число
export const grossDiffers = (net: number, gross: number) => Math.abs(gross - net) >= 0.005;
